export const INVOICE_SORT_FIELDS = {
    ID: 'id',
    SUPPLIER_NAME: 'supplierName',
    DATE: 'date',
    UPLOADED_AT: 'uploadedAt',
    AMOUNT: 'amount',
    AMOUNT_BEFORE_VAT: 'amountBeforeVat',
    STATUS: 'status',
    APPROVER: 'approver',
};

export const excelColumns = [
    { field: "booknum", headerName: "מספר חשבונית" },
    { field: "supplierName", headerName: "ספק" },
    { field: "date", headerName: "תאריך" },
    { field: "amount", headerName: "סכום" },
    { field: "amountBeforeVat", headerName: "סכום לפני מע\"מ" },
    { field: "status", headerName: "סטטוס" },
    { field: "approver", headerName: "מאשר" },
];
